import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Projects.css';
import projects from './projectData';

const Projects = () => {
  const navigate = useNavigate();

  const handleDetailClick = (projectId) => {
    navigate(`/project/${projectId}`);
  };

  return (
    <div className="projects-container">
      <div className="projects-header">
        <h1>Syed Faraz Abbas Zaidi</h1>
        <h4>Senior MERN Stack Developer</h4>
        <hr className='mt-4' />
        <p className='mt-4' >Hello! I am a professional MERN Stack Developer with expertise in building modern, scalable, and responsive web applications. I specialize in full-stack development using MongoDB, Express.js, React.js, and Node.js, ensuring smooth integration between frontend and backend systems. I work on both the client-side and server-side, creating user-friendly interfaces and developing powerful backend APIs. My focus is on delivering high-performance, secure, and maintainable applications tailored to business needs.</p>
        <h2 className='mt-4' >My Skills</h2>
        <p className='mt-4' >
        ✅ React.js & Next.js & TypeScript
✅ Node.js & Express.js
✅ MongoDB & Mongoose
✅ Redux / Context API
✅ REST APIs & API Integration
✅ MUI, Tailwind CSS, Ant Design, React Bootstrap
✅ HTML5, CSS3, SASS, JavaScript, jQuery
✅ WordPress & Photoshop
        </p>
        <a 
              href="https://farazzaidi.surge.sh/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary mt-4"
            >
              See Who is Faraz
            </a>
       
            <hr className='mt-4' />
      </div>
      <h2 className='mt-4 text-center' >My Projects</h2>
      
      <div className="projects-grid">
        
        {projects.map((project) => (
          <div key={project?.id} className="project-card">
            <div className="project-image"  onClick={() => handleDetailClick(project?.id)}>
              <img src={project?.image} alt={project?.title} />
            </div>
            <div className="project-content">
              <h3>{project?.title}</h3>
              <p>{project?.description}</p>
              <div className="project-technologies">
                {project?.technologies.map((tech, index) => (
                  <span key={index} className="tech-tag">{tech}</span>
                ))}
              </div>
              <div className="text-right">
                <button 
                  onClick={() => handleDetailClick(project?.id)}
                  className="btn btn-detail"
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
